// @ts-nocheck
import React, { useEffect, useRef } from 'react';
import { compose } from '../../core';
import OneonOneHomeView from '../components/OneOnoneHomeView'
import NotFound from '../../page/containers/NotFound'
import { useHistory } from 'react-router-dom';
import { globalPermissionValidator } from 'modules/look';
import { oneonone_permission } from 'Permissions/oneonone.permission';
import NoPermissionView from 'modules/kudos-user/component/NoPermissionComponent';
import MeetingAiTipContainer from 'modules/ai-tips/container/meeting-ai-tip-container';
import { withApollo } from '@apollo/client/react/hoc';
import { MEETING_SUBSCRIPTION } from '../graphql/MeetingSubscription.gql';
const OneonOneHomeContainer = props => {
  const { userPermission, client } = props
  const history = useHistory();
  const typeList = ['upcoming', '1_1', 'future']
  const meetingSubscription = useRef(null)
  let type = props.match.params.type;
  const [permission, setpermission] = React.useState()
  const [newlyCreatedMeeting, setNewlyCreatedMeeting] = React.useState(null)

  React.useEffect(() => {
    if (userPermission?.length) {
      let permission = globalPermissionValidator(oneonone_permission, userPermission)
      setpermission(permission)
    }
    else {
      setpermission(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPermission])

  React.useEffect(() => {
    if (permission && permission?.requried_permission)
      subscribeToMore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permission])

  useEffect(() => {
    return () => {
      if (meetingSubscription.current) {
        meetingSubscription.current.unsubscribe()
        meetingSubscription.current = null
      }
    }
  }, [])

  const subscribeToMore = async () => {
    try {
      if (!meetingSubscription.current) {
        meetingSubscription.current = client.subscribe({
          query: MEETING_SUBSCRIPTION,
        }).subscribe({
          next(result) {
            if (result?.data?.meetingSubscription) {
              switch (result.data.meetingSubscription.mutation) {
                case "CREATE":
                  setNewlyCreatedMeeting(result.data.meetingSubscription?.meeting)
                  break;
                case "UPDATE":
                  setNewlyCreatedMeeting(result.data.meetingSubscription.meeting)
                  break;
                default: {
                  break;
                }
              }
            }
          }
        })
      }
    } catch (e) {
      console.error(e)
    }
  }

  if (!typeList.includes(type)) {
    return (
      <>
        <NotFound></NotFound>
      </>
    )
  } else {
    return (
      <>
        {
          (permission && permission?.requried_permission) && (
            <OneonOneHomeView
              {...props}
              type={type}
              history={history}
              permission={permission}
              newlyCreatedMeeting={newlyCreatedMeeting}
              setNewlyCreatedMeeting={setNewlyCreatedMeeting}
            />
          )
        }

        {
          (permission && !permission?.requried_permission) && (
            <NoPermissionView />
          )
        }
        {permission && permission?.runpod_permission && <MeetingAiTipContainer  {...props} />}
      </>
    );
  }


};

export default compose(withApollo)(OneonOneHomeContainer);
